import React, {Fragment} from 'react';
import { Wide, WideToolbar, WideRow, Compact, CompactToolbar, CompactRow, Label } from '@newageerp/ui.form.base.form-pack';
import { useTranslation } from 'react-i18next'
import { InputFloat } from "@newageerp/ui.form.base.form-pack";

interface Props {
    element: any;
    onChange: (key: string, value: any) => void,
    compact?: boolean,

    onSave: () => void,
    onCancel: () => void,
}

export default function TripKmsForm(props: Props) {
    const { element, onChange } = props;
    const { t } = useTranslation();

    if (props.compact) {
        return (
            <Compact>
                <CompactRow label={<Label>{t('KM pagal autoroute')}</Label>} control={<InputFloat onChangeFloat={(e: any) => onChange('autoRouteKm', e)} value={element.autoRouteKm} className={"field-float"}/>}/>
<CompactRow label={<Label>{t('Nefiksuojama paklaida, KM')}</Label>} control={<InputFloat onChangeFloat={(e: any) => onChange('autoRouteKmAllowedDiff', e)} value={element.autoRouteKmAllowedDiff} className={"field-float"}/>}/>
                <CompactToolbar onSave={props.onSave} onCancel={props.onCancel} />
            </Compact>
        )
    }

    return (
        <Wide>
            <WideRow label={<Label>{t('KM pagal autoroute')}</Label>} control={<InputFloat onChangeFloat={(e: any) => onChange('autoRouteKm', e)} value={element.autoRouteKm} className={"field-float"}/>}/>
<WideRow label={<Label>{t('Nefiksuojama paklaida, KM')}</Label>} control={<InputFloat onChangeFloat={(e: any) => onChange('autoRouteKmAllowedDiff', e)} value={element.autoRouteKmAllowedDiff} className={"field-float"}/>}/>
            <WideToolbar onSave={props.onSave} onCancel={props.onCancel} />
        </Wide>
    )
}